<template>
  <div :class="isVertical ? 'is-flex-direction-column' : 'is-flex'">
    <p
      class="is-black is-size-5 is-flex-grow-1"
      :class="{ 'is-absolute': isAbsolute, 'm-b-5': isVertical }"
    >
      {{ leftLabel }}
    </p>
    <TooltipView position="is-bottom" type="is-dark" multilined :label="tooltipLabel">
      <p class="has-text-primary has-text-weight-semibold">
        {{ rightLabel }}
      </p>
    </TooltipView>
  </div>
</template>

<script>
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FormSubLabelTooltip',
  components: { TooltipView },
  props: {
    tooltipLabel: { type: String, default: '' },
    rightLabel: { type: String, default: '' },
    leftLabel: { type: String, default: '' },
    isAbsolute: { type: Boolean, default: false },
    isVertical: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
p.sub-label {
  line-height: 1.25;
}
</style>
